/**
 * request was successful
 * @type {number}
 */
export const OK = 200;
/**
 * request was successful and resource was created
 * @type {number}
 */
export const CREATED = 201;
/**
 * we accepted your request but there is nothing to return (e.g. response is empty)
 * @type {number}
 */
export const NO_CONTENT = 204;
/**
 * request is missing required parameters
 * @type {number}
 */
export const BAD_REQUEST = 400;
/**
 * your API key is wrong or user not authorized (not logged in)
 * @type {number}
 */
export const UNAUTHORIZED = 401;
/**
 * access denied (e.g. user / application is not allowed to use the resource)
 * @type {number}
 */
export const FORBIDDEN = 403;
/**
 * resource could not be found
 * @type {number}
 */
export const NOT_FOUND = 404;
/**
 * specified method is not allowed for resource
 * @type {number}
 */
export const METHOD_NOT_ALLOWED = 405;

/**
 * request conflict with the current state of the target resource
 * @type {number}
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/409
 */
export const CONFLICT = 409;

/**
 * validation errors. Errors are specified in response body (see below)
 * @type {number}
 */
export const UNPROCESSABLE_ENTITY = 422;
/**
 * you exceeded the rate limit (see X-Rate-Limit headers)
 * @type {number}
 */
export const TOO_MANY_REQUESTS = 429;
/**
 * something went wrong on our side
 * @type {number}
 */
export const INTERNAL_SERVICE_ERROR = 500;
/**
 * invalid response or timeout from external service
 * @type {number}
 */
export const EXTERNAL_SERVICE_ERROR = 502;
/**
 * there is planned service outage
 * @type {number}
 */
export const SERVICE_UNAVAILABLE = 503;
